import { cn } from '@/lib/cn'

interface SpinnerProps {
  className?: string
  label?: string
}

export function Spinner({ className, label = 'Wczytywanie' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-current border-t-transparent',
        className ?? 'h-4 w-4',
      )}
    />
  )
}

export function FullScreenLoader({ label = 'Wczytywanie…' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <Spinner className="h-8 w-8 text-primary" label={label} />
      <p className="text-sm font-semibold text-on-surface-variant">{label}</p>
    </div>
  )
}

/** Zastępczy blok treści na czas wczytywania danych. */
export function SkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-3 p-6" aria-hidden="true">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="h-12 animate-pulse rounded-lg bg-surface-container" />
      ))}
    </div>
  )
}
